import React, { useContext } from 'react';
import classNames from 'classnames';
import { BasketLine, OrderSummary } from '@/components/shared';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetBasket } from '@/generated/basket';
import { ApplicationLine } from '../ApplicationLine';
import styles from './BasketSummary.module.scss';

export interface BasketSummaryProps {
	isOpportunity?: boolean;
}

export const BasketSummary: React.FunctionComponent<BasketSummaryProps> = ({ isOpportunity }) => {
	const { segmentationId } = useContext(SegmentationContext);
	const { data: basket } = useGetBasket(segmentationId);

	return (
		<>
			<div className={classNames(styles.linesWrapper, 'u-scroll-wrapper-y')}>
				{basket?.data.applicationLines.map((application) => (
					<ul key={application.id} className={styles.linesList}>
						<ApplicationLine applicationLine={application} isQuickBasket />
					</ul>
				))}
				<ul>
					{basket?.data.lines.map((line) => (
						<li key={line.id}>
							<BasketLine line={line} isQuantityReadOnly isQuickBasket />
						</li>
					))}
				</ul>
			</div>
			<OrderSummary
				className={isOpportunity ? styles.opportunityOrderSummary : styles.orderSummary}
				basket={basket?.data ?? null}
			/>
		</>
	);
};
